module.exports = __webpack_public_path__ + "static/media/video-placeholder.579b4702.jpg";